module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/Luminary-homepage-3-L-1024x576.258b81c.jpg";